import React from "react";
import { IKeyValue } from "../../../Model/UI";
// import "./AccessNowDetailKeyValueList.scss";
import { KeyValueList } from "../../KeyValueList/KeyValueList";
import { IAccessApprovals } from "Model/ServerResponse/IAccessApprovals";

export interface IAccessApprovalsDetailKeyValueListProp {
  accessApprovals: IAccessApprovals;
}

export function AccessApprovalsDetailKeyValueList(props: IAccessApprovalsDetailKeyValueListProp) {
  function getHeaderTableUI() {
    let _data = getKeyValueListData();
    return (
        <div className="accessnow-details-key-value">
          <KeyValueList data={_data} />
        </div>
    );
  }

  function getKeyValueListData(): IKeyValue[] {
    let dataArray: IKeyValue[] = [];
    if (props.accessApprovals?.approvalSystemId)
      dataArray.push({
        _key: "Approval System ID",
        value: props.accessApprovals.approvalSystemId,
        seperator: ":",
      });
    if (props.accessApprovals?.approvalSystemId)
      dataArray.push({
        _key: "Requestor ID",
        value: props.accessApprovals.requestorID,
        seperator: ":",
      });
    if (props.accessApprovals?.facilityGroupName)
      dataArray.push({
        _key: "Facility Group Name",
        value: props.accessApprovals.facilityGroupName,
        seperator: ":",
      });
    if (props.accessApprovals?.fromDate)
      dataArray.push({
        _key: "From Date",
        value: props.accessApprovals.fromDate,
        seperator: ":",
      });
    if (props.accessApprovals?.toDate)
      dataArray.push({
        _key: "To Date",
        value: props.accessApprovals.toDate,
        seperator: ":",
      });
    return dataArray;
  }

  return getHeaderTableUI();
}
